import React, { useEffect, useRef, useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import "./assets/css/Navbar.css";

import logoImg from "./assets/images/Logo.webp";

const CONTACT_EMAIL = "corporate@apexoindustrial.com";
const CONTACT_PHONE = "+91 9359466302";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  const menuRef = useRef(null);

  /* ===================================
            Sticky Navbar
  =================================== */

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ===================================
        Close Sidebar on Outside Click
  =================================== */

  useEffect(() => {
    const closeMenu = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", closeMenu);

    return () =>
      document.removeEventListener(
        "mousedown",
        closeMenu
      );
  }, []);

  /* ===================================
            Close on ESC
  =================================== */

  useEffect(() => {
    const esc = (e) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("keydown", esc);

    return () =>
      document.removeEventListener(
        "keydown",
        esc
      );
  }, []);

  /* ===================================
              Body Scroll Lock
  =================================== */

  useEffect(() => {
    document.body.style.overflow = menuOpen
      ? "hidden"
      : "auto";
  }, [menuOpen]);

  return (
    <>
      <header
        className={`apexo-navbar ${
          sticky ? "sticky" : ""
        }`}
      >
        <div className="container">

          <div className="navbar-wrapper">

            {/* ================= Logo ================= */}

            <ScrollLink
              to="home"
              smooth={true}
              duration={300}
              offset={-80}
              className="navbar-brand"
            >
              <img
                src={logoImg}
                alt="Apexo Industrial"
                className="logo-img"
              />

              <div className="brand-text">
                <h2>
                  Apexo
                  <span>Industrial</span>
                </h2>
              </div>
            </ScrollLink>

            {/* ================= Desktop Menu ================= */}

            <nav className="desktop-menu">

              <ScrollLink
                to="home"
                smooth={true}
                duration={300}
                spy={true}
                offset={-80}
                activeClass="active"
                className="nav-link"
              >
                Home
              </ScrollLink>

              <ScrollLink
                to="about"
                smooth={true}
                duration={300}
                spy={true}
                offset={-80}
                activeClass="active"
                className="nav-link"
              >
                About
              </ScrollLink>

              <ScrollLink
                to="products"
                smooth={true}
                duration={300}
                spy={true}
                offset={-80}
                activeClass="active"
                className="nav-link"
              >
                Products
              </ScrollLink>

              <ScrollLink
                to="contact"
                smooth={true}
                duration={300}
                spy={true}
                offset={-80}
                activeClass="active"
                className="nav-link"
              >
                Contact
              </ScrollLink>

            </nav>

            {/* ================= Contact ================= */}

            <div className="navbar-contact">

              <a href={`mailto:${CONTACT_EMAIL}`}>

                <i className="bi bi-envelope-fill"></i>

                {CONTACT_EMAIL}

              </a>

              <a href={`tel:${CONTACT_PHONE}`}>

                <i className="bi bi-telephone-fill"></i>

                {CONTACT_PHONE}

              </a>

            </div>

            {/* ================= Hamburger ================= */}

            <button
              className={`menu-toggle ${
                menuOpen ? "active" : ""
              }`}
              onClick={() =>
                setMenuOpen(!menuOpen)
              }
              aria-label="Toggle Menu"
              aria-expanded={menuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

          </div>

        </div>
      </header>

      {/* ================= Sidebar ================= */}

      <aside
        ref={menuRef}
        className={`mobile-sidebar ${
          menuOpen ? "show" : ""
        }`}
      >

        <div className="mobile-brand">

          <img
            src={logoImg}
            alt="Logo"
          />

          <h4>
            Apexo
            <span>Industrial</span>
          </h4>

        </div>

        <ScrollLink
          to="home"
          smooth={true}
          duration={300}
          spy={true}
          offset={-80}
          activeClass="active"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          Home
        </ScrollLink>

        <ScrollLink
          to="about"
          smooth={true}
          duration={300}
          spy={true}
          offset={-80}
          activeClass="active"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          About
        </ScrollLink>

        <ScrollLink
          to="products"
          smooth={true}
          duration={300}
          spy={true}
          offset={-80}
          activeClass="active"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          Products
        </ScrollLink>

        <ScrollLink
          to="contact"
          smooth={true}
          duration={300}
          spy={true}
          offset={-80}
          activeClass="active"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          Contact
        </ScrollLink>

        <div className="mobile-contact">

          <a href={`mailto:${CONTACT_EMAIL}`}>

            <i className="bi bi-envelope-fill"></i>

            {CONTACT_EMAIL}

          </a>

          <a href={`tel:${CONTACT_PHONE}`}>

            <i className="bi bi-telephone-fill"></i>

            {CONTACT_PHONE}

          </a>

        </div>

      </aside>

      {/* ================= Overlay ================= */}

      {menuOpen && (
        <div
          className="menu-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;